import { authService } from '@libs/data-access/queries'

import { setAuthCookies } from '../authServiceUtils'

export const useImpersonateUserOnSwitchAccount = () => {
  const postImpersonateUser = authService.usePostImpersonateUser()

  return async ({
    account_slug_or_id,
    user_id
  }: {
    account_slug_or_id: string | number
    user_id: string | number
  }) => {
    const impersonateResponse = await postImpersonateUser.mutateAsync({
      pathParams: {
        account_slug_or_id
      },
      queryParams: {
        user_id
      }
    })

    setAuthCookies({
      impersonatedMembershipId: impersonateResponse.membership_id
    })
  }
}
